module.exports = __webpack_public_path__ + "static/media/From Concept to Capital_ Presented by Contrary.dfe80bbb.png";